export const API_DOMAIN = import.meta.env.VITE_API_URL;

export const authHeaders = (token) => ({ Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' });

export const parseResponse = (response) => {
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    return response.json();
};
